import { useParams } from 'react-router-dom';
import { TimetableVersionLessonsTable } from '../../../../../../components/Lessons/TimetableVersion/Table/TimetableVersionLessonsTable';

export const PlanTimetableLessons = ({ subjectContainerLessons }: { subjectContainerLessons?: boolean }) => {
  const { versionUuid } = useParams();

  return (
    <>
      {versionUuid && (
        <TimetableVersionLessonsTable versionUuid={versionUuid} subjectContainerLessons={subjectContainerLessons} />
      )}
    </>
  );
};
